import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ListButton from '../elements/ListButton';
import actions from '../../actions';
import {checkRead} from '../../helpers/feedbackHelpers';
import history from "../../history";


const { updateMyState } = actions.gameStateInput;
const { updateRead } = actions.feedback;

class TaxItem extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    title: PropTypes.string,
    notification: PropTypes.shape({}),
    icon: PropTypes.any,
    globas: PropTypes.any,
    points: PropTypes.any,
    feedbackData: PropTypes.shape({}),
    dataList: PropTypes.array,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    sliderValue: PropTypes.number,
    collaborationValue: PropTypes.array,
    sliderKey: PropTypes.string,
    collaborationKey: PropTypes.string,
    notificationReference: PropTypes.string,
    reverseGlobasPoints: PropTypes.bool,
    saving: PropTypes.bool,
    selected: PropTypes.bool,
  };
  static defaultProps = {
    onChange: () => {},
    reverseGlobasPoints: true,
    title: 'title',
    icon: '',
    globas: 0,
    points: 0,
    dataList: [],
    minValue: 0,
    maxValue: 999,
    sliderKey: 'slider',
    collaborationKey: 'collaboration',
    feedbackData: {},
    notificationReference: '',
    notification: {},
    saving: false,
    selected: false,
  };
  constructor (props) {
    super(props);
    this.state = {
      showDropDown: this.props.showDropdown,
      capNotification: false,
      saving: this.props.saving
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange = (key, value) => {
    const { cap } = this.props;
    let capNotification;
    if (cap !== undefined) {
      if (value <= cap && value > 0) {
        capNotification = false;
      }
      if (value > cap) {
        capNotification = true;
      }
    }
    this.setState({
      capNotification: capNotification,
      sliderValue: value
    });

    this.props.dispatch(updateMyState({ [key]: value }));
  };

  componentDidMount() {
    if(this.props.gameState.difficulty === 'BASIC') {
      this.markAsRead();
    }
  }

  markAsRead = () => {
    if (this.props.notification.reference && !checkRead(this.props.notification, false, 0, false)) {
      if ( this.props.feedback.all[this.props.feedback.currentRound].feedback.find((c) => (c.id === this.props.notification.reference)).economie === null ){
        this.props.dispatch(updateRead(this.props.notification.reference, {read: true, economie: true}));
      } else {
        this.props.dispatch(updateRead(this.props.notification.reference, {read: true, economie: false}));
      }
    }
  };

  componentWillReceiveProps(props) {
    if (props.sliderValue > props.cap) {
      this.setState({capNotification: true});
    }
    if (this.props.feedbackData.show !== props.feedbackData.show) {
      this.setState({showDropDown: false});
    }
    if(props.saving !== this.state.saving){
      if(props.saving) {
        this.setState({
          saving: props.saving,
        })
        history.push('/taxes/');
      } else {
        this.setState({
          saving: props.saving,
        })
      }
    }
  }

  render() {
    const { props, state } = this;
    if(this.props.gameState.difficulty === 'BASIC') {
      this.markAsRead();
    }
    return (
      <span className={this.props.showDropdown ? 'show' : ''}>
        <Link to={this.props.showDropdown ? '/taxes' : '/taxes/' + props.popupId.substring(5)}>
          <ListButton
            className={` ${props.selected ? 'selected' : ''} ${props.showDropdown ? 'show' : ''}`}
            onClick={() => {
              if (props.feedbackData.show) {
                this.markAsRead();
              }
              if (props.registerShown) {
                props.registerShown();
              }
              this.setState({ showDropDown: !state.showDropDown });
            }}
            feedbackCount={props.notification.read && !checkRead(props.notification, false, 0, false) ? 1 : 0}
            bgColor={'white'}
            title={props.title}
            icon={props.icon}
            reverseGlobasPoints={props.reverseGlobasPoints}
            arrow={true}
            bigArrow={true}
            globas={props.globas}
            points={props.points}
          />
        </Link>
      </span>
    );
  }
}

export default connect(state => state)(TaxItem);



// WEBPACK FOOTER //
// ./src/components/desktop/TaxItem.js